import React, { useCallback, useEffect, useState } from 'react';
import LANGUAGE_CONTROLLER from '../../controllers/languages';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import { debounce } from 'lodash';
import { PERIOD_OPTIONS } from '../../utils/enums'
import { SSelect } from '@avalara/skylab-sdk/react';

const SearchByVatBox = ({ languageString, onInputChange, countryCode, startDate }) => {
    const [boxValue, setBoxValue] = useState('');
    const [period, setPeriod] = useState("0");
    const debouncedSearch = useCallback(
        debounce((countryCode, boxValue, period, startDate) => {
            if (boxValue.trim()) {
                onInputChange(countryCode, boxValue, period, startDate)
            }
        }, 1000),
        []
    );

    useEffect(() => {
        return () => {
            debouncedSearch.cancel();
        };
    }, [debouncedSearch]);

    useEffect(() => {
        if (boxValue.trim()) {
            debouncedSearch(countryCode, boxValue, period, startDate);
        }
    }, [boxValue, period, debouncedSearch]);

    const handleInputChangeBoxValue = (event) => {
        if (!event || !event.target || typeof event.target.value !== 'string') {
            console.warn('Invalid input or event structure');
            return;
        }
        const value = event.target.value.replace(/\s/g, '');
        setBoxValue(value);
    };

    const handleKeyDown = (event) => {
        if(event.keyCode === 13) {
            event.preventDefault();
        }
    }
    
    const handleDropdownChange = (event) => {
        const value = event.detail.item.value;
        setPeriod(value);
    }
    return (
        <div>
            <div className="mt10">
            <s-alert class="mt10" status="warning" data-testid="banner">
                    <div>
                        <LanguageStringResolver string='vatCodeSearch_vatBox_warning_banner'/>
                    </div>
            </s-alert>
            </div>
            <fieldset>
                <div className="mt10 clear"></div>
                <s-box name="form-panel">
                    <s-row>
                        <s-col span="1">
                            <div className="form-group">
                                    <label>
                                        <LanguageStringResolver string='vatCodeSearch_vatBox_label'/>
                                    </label>
                            </div>
                        </s-col>
                        <s-col span="3">
                            <div className="form-group">
                                    <input
                                        className="form-control"
                                        value={boxValue}
                                        name='vatCode'
                                        onChange={handleInputChangeBoxValue}
                                        onKeyDown={handleKeyDown}
                                        data-testid="vatBoxNameValue"
                                        placeholder={LANGUAGE_CONTROLLER.format(languageString, 'vatCodeSearch_vatBox_placeholder')}
                                    />
                            </div>
                        </s-col>
                        <s-col span="3">
                            <div className="form-group">
                                <SSelect
                                    inputId="vat-box-period-selector"
                                    className="form-control"
                                    name="vatBoxDropdown"
                                    optionsList={PERIOD_OPTIONS.map((option) => ({
                                        key: option.value,
                                        value: option.value,
                                        label: LANGUAGE_CONTROLLER.format(languageString, option.languageString),
                                        selected: period === option.value
                                    }))}
                                    multiple={false}
                                    onS-select={handleDropdownChange}
                                />
                            </div>
                        </s-col>
                    </s-row>
                </s-box>
            </fieldset>
        </div>
    );

};

export default SearchByVatBox;